/* kw-spy v1.0
 * Behavioral event logger + Alia popup spy for kewlioo.com
 * Purpose: capture the full user behavior stream and Alia popup lifecycle
 * (1st/2nd/3rd show per user) so the smart trigger can be reverse engineered
 * and later replaced with a native self-calibrating trigger.
 *
 * Ships events to the cashback app ingest endpoint (see spy-ingest.js).
 * Config comes from window.KWSPY, set in snippets/kw-spy.liquid.
 */
(function () {
  'use strict';
  if (window.__kwspyLoaded) return;
  window.__kwspyLoaded = 1;

  var CFG = window.KWSPY || {};
  if (!CFG.endpoint) return;
  try { if (navigator.webdriver) return; } catch (e) {}
  try { if (window.Shopify && window.Shopify.designMode) return; } catch (e) {}

  /* ---------------- consent gate (Shopify Customer Privacy API) ---------------- */
  function consentAllowed() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') {
        return cp.analyticsProcessingAllowed() !== false;
      }
    } catch (e) {}
    return true;
  }

  if (consentAllowed()) { boot(); }
  else {
    document.addEventListener('visitorConsentCollected', function h() {
      if (consentAllowed()) {
        document.removeEventListener('visitorConsentCollected', h);
        boot();
      }
    });
  }

  function boot() {

    /* ---------------- helpers ---------------- */
    function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
    function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
    function jGet(k, d) { try { var v = lsGet(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } }
    function jSet(k, o) { try { lsSet(k, JSON.stringify(o)); } catch (e) {} }
    function trunc(s, n) { return s == null ? undefined : String(s).slice(0, n); }
    function r1(x) { return Math.round(x * 10) / 10; }
    function uuid() {
      try { return crypto.randomUUID(); } catch (e) {}
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0; return (c === 'x' ? r : (r & 3 | 8)).toString(16);
      });
    }
    function sha256(s) {
      return crypto.subtle.digest('SHA-256', new TextEncoder().encode(s)).then(function (buf) {
        return Array.prototype.map.call(new Uint8Array(buf), function (b) {
          return ('0' + b.toString(16)).slice(-2);
        }).join('');
      });
    }
    // Word-boundary-ish match so "australia", "socialia" etc never false-positive
    var ALIA_WORD = /(^|[^a-z])alia([^a-z]|$)/i;
    function aliaUrl(u) {
      try {
        var h = new URL(u, location.href).hostname;
        if (h === location.hostname) return false;
        return /(^|\.)alia[a-z0-9-]*\./i.test(h) || /aliapopups|alialabs|usealia/i.test(h);
      } catch (e) { return false; }
    }
    function isMobile() {
      try { return matchMedia('(pointer:coarse)').matches || innerWidth < 768; } catch (e) { return innerWidth < 768; }
    }
    function productHandle() {
      var m = location.pathname.match(/\/products\/([a-z0-9\-_]+)/i);
      return m ? m[1] : undefined;
    }
    function navType() {
      try { var n = performance.getEntriesByType('navigation')[0]; return n ? n.type : undefined; } catch (e) { return undefined; }
    }
    function klaviyoState() {
      var js = !!(window._learnq || window.klaviyo);
      var idc = /(^|;\s*)__kla_id=/.test(document.cookie);
      return { js: js, id: idc };
    }
    function aliaStorage() {
      var ls = {}, ck = [];
      try {
        for (var i = 0; i < localStorage.length; i++) {
          var k = localStorage.key(i);
          if (ALIA_WORD.test(k)) ls[k] = redactPII(trunc(localStorage.getItem(k), 6000));
        }
      } catch (e) {}
      try {
        document.cookie.split(';').forEach(function (c) {
          var k = c.split('=')[0].trim();
          if (ALIA_WORD.test(k)) ck.push(k);
        });
      } catch (e) {}
      return { ls: ls, ck: ck };
    }

    /* ---------------- identity ---------------- */
    var aid = lsGet('kwspy_aid');
    if (!aid) {
      var m = document.cookie.match(/(?:^|;\s*)_kwspy_aid=([0-9a-f\-]{20,40})/i);
      aid = (m && m[1]) || uuid();
      lsSet('kwspy_aid', aid);
    }
    try {
      var parts = location.hostname.split('.');
      var dom = parts.length > 2 ? parts.slice(-2).join('.') : location.hostname;
      document.cookie = '_kwspy_aid=' + aid + '; max-age=34128000; path=/; domain=.' + dom + '; SameSite=Lax; Secure';
    } catch (e) {}

    /* ---------------- lifetime counters + session ---------------- */
    var now0 = Date.now();
    var C = jGet('kwspy_c', { v: 0, pv: 0, shows: 0, last_show: 0, last_close: null, signed: 0, sub: 0, f: now0 });

    // Do not track users Alia already knows: opted in, has email or phone on file, or arrived
    // from an email/SMS link (which only reaches existing contacts). They are a different
    // population Alia treats differently, so tracking them would pollute the cold-visitor
    // trigger data. Known users bail here with zero overhead: no listeners, observers, timers
    // or network patches are installed.
    function arrivedFromKnownChannel() {
      try {
        var q = new URLSearchParams(location.search);
        if (q.has('_kx')) return true;                                   // Klaviyo personalized-contact identifier
        var med = (q.get('utm_medium') || '').toLowerCase();
        var src = (q.get('utm_source') || '').toLowerCase();
        if (/^(email|e-mail|sms|mms|text|push)$/.test(med)) return true;
        if (/klaviyo|postscript|attentive|omnisend|mailchimp|sendlane|drip|listrak|emotive|email|sms/.test(src)) return true;
      } catch (e) {}
      return false;
    }
    var knownChannel = arrivedFromKnownChannel();
    var subscribed = !!(C.signed || C.sub) || knownChannel;
    var TRACK = !subscribed;
    if (subscribed) {
      if (knownChannel && !C.sub) { C.sub = 1; try { jSet('kwspy_c', C); } catch (e) {} }
      return;
    }
    function markSubscribed() {
      if (subscribed) return;
      subscribed = true; TRACK = false;
      try { C.sub = 1; jSet('kwspy_c', C); } catch (e) {}
    }

    var sess = jGet('kwspy_sess', null);
    var newSession = !sess || (now0 - (sess.last || 0)) > 30 * 60 * 1000;
    if (newSession) {
      C.v = (C.v || 0) + 1;
      sess = { sid: 's' + now0.toString(36) + '-' + uuid().slice(0, 8), start: now0, last: now0, n: 0, act: 0 };
    }
    var tab;
    try {
      tab = sessionStorage.getItem('kwspy_tab');
      if (!tab) { tab = Math.random().toString(36).slice(2, 8); sessionStorage.setItem('kwspy_tab', tab); }
    } catch (e) { tab = 't' + Math.random().toString(36).slice(2, 6); }

    /* ---------------- transport ---------------- */
    var Q = [], seq = 0, EMITTED = 0, sentFails = 0;
    var ring = [], RINGMAX = 40;          // rolling behavior buffer, lives in the browser only
    var netBodies = [];                    // buffered Alia network bodies, attached on fire, else discarded
    var firedThisPage = false;
    // Only these hit the DB. Every other event stays client-side and is never sent.
    // Only these three reach the DB. Closes, polls, rewards and internal markers
    // stay client-side: dismissal method and prior-signup state ride the next
    // impression's snapshot, so they need no rows of their own.
    var PERSIST = { popup_shown: 1, popup_not_shown: 1, popup_signup: 1 };

    function send(batch, sync) {
      var payload = JSON.stringify({
        aid: aid, sid: sess.sid, tab: tab, visit: C.v,
        cid: CFG.customerId || null, cur: CFG.currency || null,
        sent: Date.now(), ev: batch
      });
      if (sync && navigator.sendBeacon) {
        try { if (navigator.sendBeacon(CFG.endpoint, new Blob([payload], { type: 'text/plain' }))) return; } catch (e) {}
      }
      try {
        fetch(CFG.endpoint, {
          method: 'POST', body: payload, keepalive: true,
          headers: { 'Content-Type': 'text/plain' }, mode: 'cors', credentials: 'omit'
        }).then(function (r) { sentFails = r.ok ? 0 : sentFails + 1; })
          .catch(function () { sentFails++; });
      } catch (e) { sentFails++; }
    }
    function flush(sync) {
      if (sentFails > 4) { Q.length = 0; return; }
      while (Q.length) {
        send(Q.splice(0, 25), sync);
        if (!sync) break;
      }
    }
    var sessDirty = false, sessSaved = 0;
    // localStorage writes are synchronous and block the main thread. Persisting the
    // session on every event (scroll, heartbeat) is the main hot-path cost, so cap
    // it to at most once every ~4s, forced on hide/unload where it actually matters.
    function saveSess(force) {
      var t = Date.now();
      if (force || t - sessSaved > 4000) { sessSaved = t; sessDirty = false; jSet('kwspy_sess', sess); }
      else sessDirty = true;
    }

    function emit(type, props) {
      var t = Date.now();
      // Always buffer into the rolling client-side trail. This is the pre-fire context.
      ring.push({ y: type, t: t });
      if (ring.length > RINGMAX) ring.shift();
      sess.last = t;
      if (CFG.debug) { try { console.log('[kwspy]', type, props); } catch (err) {} }
      // Persist to the DB only for popup events, and only while tracking (a user who
      // subscribes mid-session stops being persisted from that point).
      if (TRACK && PERSIST[type] && EMITTED <= 200) {
        EMITTED++;
        Q.push({ t: t, seq: seq++, type: type, path: trunc(location.pathname, 300), props: props || {} });
        if (Q.length > 100) Q.splice(0, Q.length - 100);
        flush(false);
      }
      saveSess(false);
    }

    /* ---------------- page + behavior state ---------------- */
    var P = { start: Date.now(), act: 0, lastAct: Date.now(), idle: false, idleStart: 0, lastIdleEnd: 0, lastIdleMs: 0, scrollMax: 0, milestones: {}, clicks: 0 };
    var lastExit = 0, lastEsc = 0, aliaUiClick = 0, ticks = 0;
    var UTM = {};
    try {
      var sp = new URLSearchParams(location.search);
      ['source', 'medium', 'campaign', 'content', 'term'].forEach(function (k) {
        var v = sp.get('utm_' + k); if (v) UTM[k] = trunc(v, 80);
      });
    } catch (e) {}

    function curScrollPct() {
      try {
        var full = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight || 0);
        return full > 0 ? Math.min(100, Math.round((pageYOffset + innerHeight) / full * 100)) : 0;
      } catch (e) { return 0; }
    }

    /* activity + idle + heartbeat */
    var actThrottle = 0;
    function onActivity(ev) {
      var t = Date.now();
      if (t - actThrottle < 400) return;
      actThrottle = t;
      if (P.idle) {
        var ms = t - P.idleStart;
        P.idle = false; P.lastIdleEnd = t; P.lastIdleMs = ms;
        emit('idle', { ms: ms });
      }
      P.lastAct = t;
    }
    ['pointermove', 'pointerdown', 'keydown', 'touchstart', 'wheel'].forEach(function (n) {
      addEventListener(n, onActivity, { passive: true, capture: true });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') lastEsc = Date.now(); }, true);

    setInterval(function () {
      var t = Date.now();
      var vis = document.visibilityState === 'visible';
      if (vis && t - P.lastAct < 10000) { P.act += 5000; sess.act += 5000; }
      else if (vis && !P.idle && t - P.lastAct >= 10000) { P.idle = true; P.idleStart = P.lastAct; }
      ticks++;
      if (vis && ticks % 3 === 0) {
        emit('heartbeat', { sp: r1((t - P.start) / 1000), ap: r1(P.act / 1000), as: r1(sess.act / 1000), sc: P.scrollMax });
      }
      flush(false);
      if (sessDirty) saveSess(true);
      if (aliaRoots.size) pruneRoots();
    }, 5000);

    /* scroll depth + mobile fast-scroll-up exit signal */
    var lastY = pageYOffset, lastYt = Date.now(), scrThrottle = 0;
    addEventListener('scroll', function () {
      var t = Date.now();
      if (t - scrThrottle < 180) return;
      scrThrottle = t;
      var pct = curScrollPct();
      if (pct > P.scrollMax) P.scrollMax = pct;
      [25, 50, 75, 90].forEach(function (ms) {
        if (pct >= ms && !P.milestones[ms]) { P.milestones[ms] = 1; emit('scroll', { d: ms }); }
      });
      var dy = pageYOffset - lastY, dt = t - lastYt;
      if (dt > 0 && dt < 500 && dy < 0 && (-dy / dt) * 1000 > 2200 && t - lastExit > 15000) {
        lastExit = t; emit('exit_intent', { kind: 'scroll_up' });
      }
      lastY = pageYOffset; lastYt = t;
    }, { passive: true });

    /* desktop exit intent */
    document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && e.clientY <= 5) {
        var t = Date.now();
        if (t - lastExit > 10000) { lastExit = t; emit('exit_intent', { kind: 'mouse_top' }); }
      }
    });

    /* visibility + leave */
    document.addEventListener('visibilitychange', function () {
      emit('vis', { s: document.visibilityState });
      if (document.visibilityState === 'hidden') { jSet('kwspy_c', C); saveSess(true); flush(true); }
    });
    addEventListener('pagehide', function () {
      // Optional negative sample: Alia matched (user eligible) but no show this pageview.
      // Off by default. Enable via KWSPY.captureMatchedNoShow to preserve trigger-timing negatives.
      if (TRACK && CFG.captureMatchedNoShow && matchedAt && !firedThisPage) {
        emit('popup_not_shown', { reason: 'matched_no_show', snapshot: buildSnapshot(Date.now(), C.last_show || 0, true) });
      }
      emit('page_leave', { ms: Date.now() - P.start, ap: r1(P.act / 1000), sc: P.scrollMax });
      saveSess(true); jSet('kwspy_c', C);
      flush(true);
    });
    addEventListener('pageshow', function (e) {
      if (e.persisted) {
        P.start = Date.now(); P.act = 0; P.scrollMax = 0; P.milestones = {}; P.clicks = 0;
        sess.n++; C.pv++; jSet('kwspy_c', C);
        emit('page_view', { pt: CFG.pageType || '', n: sess.n, bf: 1, product: productHandle() });
      }
    });

    /* clicks (coarse, interactive elements only) + alia UI click attribution */
    document.addEventListener('click', function (e) {
      var t = Date.now();
      try {
        var cp = e.composedPath ? e.composedPath() : [];
        for (var i = 0; i < cp.length; i++) {
          if (aliaRoots.has(cp[i])) { aliaUiClick = t; break; }
        }
      } catch (err) {}
      var el = e.target && e.target.closest ? e.target.closest('a,button,[role="button"],input[type="submit"],select,summary,label') : null;
      if (!el || P.clicks++ > 60) return;
      var d = el.tagName.toLowerCase();
      if (el.id) d += '#' + el.id;
      else if (typeof el.className === 'string' && el.className.trim()) d += '.' + el.className.trim().split(/\s+/).slice(0, 2).join('.');
      var props = { el: trunc(d, 80) };
      var lbl = el.getAttribute('aria-label');
      var txt = (lbl != null ? lbl : (el.textContent || '')).slice(0, 160).trim();
      if (txt) props.txt = trunc(txt, 40);
      if (el.tagName === 'A' && el.getAttribute('href')) props.href = trunc(el.getAttribute('href'), 120);
      emit('click', props);
    }, true);

    /* ---------------- cart tracking ---------------- */
    var cart = { items: null, value: null }, cartT = 0;
    var cartRx = /\/cart\/(add|change|update|clear)/;
    function refreshCart(kind) {
      try {
        fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
          cart.items = c.item_count;
          cart.value = Math.round(c.total_price) / 100;
          if (kind) emit('cart', { kind: kind, items: cart.items, value: cart.value });
        }).catch(function () {});
      } catch (e) {}
    }
    function onCartMut(kind) {
      clearTimeout(cartT);
      cartT = setTimeout(function () { refreshCart(kind); }, 900);
    }
    (window.requestIdleCallback || function (f) { return setTimeout(f, 1500); })(function () { refreshCart(null); });

    /* ---------------- network spy (fetch / XHR / beacon / perf) ---------------- */
    var aliaBodies = 0, seenUrls = {};

    function redactPII(s) {
      if (!s) return s;
      // Strip emails and clearly-formatted phone numbers. Plain integers (config
      // thresholds, ids) are left alone so the trigger config stays readable.
      return String(s)
        .replace(/[a-z0-9._%+\-]+@[a-z0-9.\-]+\.[a-z]{2,}/gi, '[email]')
        .replace(/\+\d[\d\s().\-]{6,}\d/g, '[phone]')
        .replace(/\b\d{3}[\s.\-]\d{3}[\s.\-]\d{4}\b/g, '[phone]');
    }

    function keepNet(rec) {
      if (rec.body) {
        rec.body = redactPII(rec.body);
        // Alia's own user object reveals a known contact. Any of these means already known.
        if (!subscribed && /"(?:emailOptIn|smsOptIn|hasEmail|hasPhone)":true/.test(rec.body)) markSubscribed();
      }
      try { netBodies.push(rec); if (netBodies.length > 8) netBodies.shift(); } catch (e) {}
      // ring marker only; the body rides along inside the fire payload, never streamed on its own
      emit('alia_net', { u: rec.u, m: rec.m, st: rec.st, src: rec.src, has_body: !!rec.body });
    }

    if (window.fetch) {
      var _f = window.fetch;
      window.fetch = function (input, init) {
        var url = '', method = 'GET';
        try {
          url = typeof input === 'string' ? input : (input && input.url) || '';
          method = (init && init.method) || (input && input.method) || 'GET';
        } catch (e) {}
        var p = _f.apply(this, arguments);
        try {
          if (cartRx.test(url)) onCartMut((url.match(cartRx) || [])[1]);
          if (aliaUrl(url)) {
            seenUrls[url] = 1;
            var rec = { u: trunc(url, 200), m: method, src: 'fetch' };
            p.then(function (res) {
              try {
                rec.st = res.status;
                var ct = res.headers.get('content-type') || '';
                if (aliaBodies < 6 && ct.indexOf('json') > -1) {
                  aliaBodies++;
                  res.clone().text().then(function (txt) { rec.body = trunc(txt, 20000); keepNet(rec); })
                    .catch(function () { keepNet(rec); });
                } else keepNet(rec);
              } catch (e) { keepNet(rec); }
            }).catch(function () { rec.err = 1; keepNet(rec); });
          }
        } catch (e) {}
        return p;
      };
    }

    try {
      var XO = XMLHttpRequest.prototype.open, XS = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function (m, u) { this.__kws = { m: m, u: String(u) }; return XO.apply(this, arguments); };
      XMLHttpRequest.prototype.send = function () {
        var i = this.__kws, x = this;
        try {
          if (i && cartRx.test(i.u)) {
            var kind = (i.u.match(cartRx) || [])[1];
            x.addEventListener('load', function () { onCartMut(kind); });
          }
          if (i && aliaUrl(i.u)) {
            seenUrls[i.u] = 1;
            x.addEventListener('load', function () {
              var rec = { u: trunc(i.u, 200), m: i.m, st: x.status, src: 'xhr' };
              try {
                if (aliaBodies < 6 && (x.getResponseHeader('content-type') || '').indexOf('json') > -1 && typeof x.responseText === 'string') {
                  aliaBodies++; rec.body = trunc(x.responseText, 4000);
                }
              } catch (e) {}
              keepNet(rec);
            });
          }
        } catch (e) {}
        return XS.apply(this, arguments);
      };
    } catch (e) {}

    try {
      if (navigator.sendBeacon) {
        var _b = navigator.sendBeacon.bind(navigator);
        navigator.sendBeacon = function (u, data) {
          try {
            var us = String(u);
            if (aliaUrl(us)) keepNet({ u: trunc(us, 200), m: 'BEACON', src: 'beacon' });
          } catch (e) {}
          return _b(u, data);
        };
      }
    } catch (e) {}

    var perfSeen = 0;
    function scanPerf() {
      try {
        var entries = performance.getEntriesByType('resource');
        for (; perfSeen < entries.length; perfSeen++) {
          var u = entries[perfSeen].name;
          if (aliaUrl(u) && !seenUrls[u]) {
            seenUrls[u] = 1;
            keepNet({ u: trunc(u, 200), src: 'perf' });
          }
        }
      } catch (e) {}
    }
    // Prefer a push-based observer over polling the resource buffer every tick.
    try {
      new PerformanceObserver(function (list) {
        var es = list.getEntries();
        for (var i = 0; i < es.length; i++) {
          var u = es[i].name;
          if (aliaUrl(u) && !seenUrls[u]) { seenUrls[u] = 1; keepNet({ u: trunc(u, 200), src: 'perf' }); }
        }
      }).observe({ type: 'resource', buffered: true });
    } catch (e) {
      setTimeout(scanPerf, 3000);
    }

    /* ---------------- alia DOM roots (for click attribution + modal/floating classification) ---------------- */
    var aliaRoots = new Set();
    var rootVis = new WeakMap();      // node -> currently counted visible (weak, no retention)
    var rootObs = new WeakMap();      // node -> scoped attribute observer
    var visibleCount = 0;
    var uiMounted = false;
    var domTimer = 0, domWasVisible = false;

    // IntersectionObserver reports viewport enter/exit using rects it already has,
    // so there is no forced layout on our side. It replaces per-frame polling.
    var io = null;
    try {
      io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) reevalRoot(entries[i].target);
          else setRootVis(entries[i].target, false);
        }
      }, { threshold: [0, 0.01, 0.25] });
    } catch (e) { io = null; }

    function looksAlia(n) {
      if (!n || n.nodeType !== 1) return false;
      var s = (n.tagName || '') + ' ' + (n.id || '') + ' ' + (typeof n.className === 'string' ? n.className : '');
      if (ALIA_WORD.test(s)) return true;
      if (n.tagName === 'IFRAME' && aliaUrl(n.src || '')) return true;
      return false;
    }
    // One targeted read of a single node, only on an actual visibility event.
    function nodeVisible(n) {
      try {
        if (!n.isConnected) return false;
        var cs = getComputedStyle(n);
        if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return false;
        var r = n.getBoundingClientRect();
        if (r.width < 40 || r.height < 40) return false;
        if (r.bottom <= 0 || r.top >= innerHeight || r.right <= 0 || r.left >= innerWidth) return false;
        return true;
      } catch (e) { return false; }
    }
    function setRootVis(n, vis) {
      var prev = rootVis.get(n) || false;
      if (vis === prev) return;
      rootVis.set(n, vis);
      visibleCount += vis ? 1 : -1;
      if (visibleCount < 0) visibleCount = 0;
      onVisChange();
    }
    function reevalRoot(n) { setRootVis(n, nodeVisible(n)); }
    function onVisChange() {
      var vis = visibleCount > 0;
      if (vis && !domWasVisible) {
        domWasVisible = true;
        if (OPEN.active) return; // SDK path already owns this open
        clearTimeout(domTimer);
        domTimer = setTimeout(function () {
          if (visibleCount > 0 && !OPEN.active) recordShow('dom', {}, (Date.now() - aliaUiClick) < 1500);
        }, 1500);
      } else if (!vis && domWasVisible) {
        domWasVisible = false;
        clearTimeout(domTimer);
        if (OPEN.active && (OPEN.source === 'dom' || OPEN.source === 'dom+sdk')) {
          var t = Date.now();
          var via = (t - aliaUiClick) < 1200 ? 'click' : ((t - lastEsc) < 1200 ? 'esc' : 'other');
          C.last_close = via; OPEN.closedAt = t; OPEN.active = false;
          emit('popup_closed', { source: 'dom', ms_open: OPEN.at ? (t - OPEN.at) : null, via: via });
          jSet('kwspy_c', C);
        }
      }
    }
    function addRoot(n) {
      if (aliaRoots.has(n)) return;
      aliaRoots.add(n);
      if (io) { try { io.observe(n); } catch (e) {} }
      // Scoped attribute observer: catches in-place show/hide (opacity/display/class
      // toggles) on this one node only, so page-wide class churn never reaches us.
      try {
        var mo = new MutationObserver(function () { reevalRoot(n); });
        mo.observe(n, { attributes: true, attributeFilter: ['style', 'class', 'hidden', 'aria-hidden'] });
        rootObs.set(n, mo);
      } catch (e) {}
      setTimeout(function () { reevalRoot(n); }, 60);
      if (!uiMounted) {
        uiMounted = true;
        setTimeout(function () {
          if (!OPEN.active) { var k = classifyKind(); emit('alia_ui', { kind: 'mounted', ui: k.kind, cover: k.cover }); }
        }, 1200);
      }
    }
    function scanNode(n) {
      if (looksAlia(n)) { addRoot(n); return; }
      try {
        if (n.querySelectorAll) {
          var hits = n.querySelectorAll('[id*="alia" i],[class*="alia" i],iframe');
          for (var i = 0; i < hits.length; i++) if (looksAlia(hits[i])) addRoot(hits[i]);
        }
      } catch (e) {}
    }
    // Drop detached roots so the Set never retains dead DOM nodes, and tear down
    // their observers. Also the fallback visibility poll when IO is unsupported.
    function pruneRoots() {
      aliaRoots.forEach(function (n) {
        if (!n.isConnected) {
          if (io) { try { io.unobserve(n); } catch (e) {} }
          var mo = rootObs.get(n); if (mo) { try { mo.disconnect(); } catch (e) {} rootObs.delete(n); }
          if (rootVis.get(n)) { visibleCount = Math.max(0, visibleCount - 1); }
          rootVis.delete(n);
          aliaRoots.delete(n);
        } else if (!io) {
          reevalRoot(n);
        }
      });
    }
    // Discovery only: childList so we notice Alia mounting. No global attribute
    // observation (that fired on every class change site-wide).
    try {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var added = muts[i].addedNodes;
          for (var j = 0; j < added.length; j++) if (added[j].nodeType === 1) scanNode(added[j]);
        }
      }).observe(document.documentElement, { childList: true, subtree: true });
      scanNode(document.documentElement);
    } catch (e) {}

    function classifyKind() {
      var area = 0, best = null;
      aliaRoots.forEach(function (n) {
        try {
          if (!n.isConnected) return;
          var r = n.getBoundingClientRect();
          var a = r.width * r.height;
          if (a > area) { area = a; best = r; }
        } catch (e) {}
      });
      if (!best || area === 0) return { kind: null, cover: null };
      var cover = Math.round(area / (innerWidth * innerHeight) * 100) / 100;
      return { kind: cover > 0.25 ? 'modal' : 'floating', cover: cover };
    }

    /* ---------------- alia SDK event hooks (ground truth) ---------------- */
    var matchedAt = 0;
    // Unified open state, written by BOTH the SDK path and the DOM fallback.
    var OPEN = { active: false, source: null, campaignID: null, popupID: null, at: 0, closedAt: 0 };

    // Shared show recorder so SDK-driven and DOM-driven shows produce identical rows.
    function recordShow(source, ids, manual) {
      var t = Date.now();
      var prevShow = C.last_show || 0;
      if (!manual) { C.shows = (C.shows || 0) + 1; C.last_show = t; }
      var occ = C.shows || 0;
      firedThisPage = true;
      var reopen = manual || (OPEN.closedAt && (t - OPEN.closedAt) < 120000);
      OPEN = { active: true, source: source, campaignID: ids.campaignID, popupID: ids.popupID, at: t, closedAt: 0 };
      var k = classifyKind();
      emit('popup_shown', {
        occurrence: occ, manual: !!manual, reopened: !!reopen, source: source,
        campaignID: ids.campaignID, campaignTitle: trunc(ids.campaignTitle, 60), popupID: ids.popupID,
        trigger: manual ? 'user_click' : ((t - lastExit) < 5000 ? 'exit_like' : 'auto'),
        kind: k.kind, cover: k.cover,
        snapshot: buildSnapshot(t, prevShow)
      });
      jSet('kwspy_c', C);
    }
    var KNOWN = ['campaignMatched', 'popupView', 'popupClose', 'signup', 'pollAnswered', 'rewardClaimed'];
    KNOWN.forEach(function (name) {
      document.addEventListener('alia:' + name, function (e) {
        try { handleAlia(name, (e && e.detail) || {}); } catch (err) {}
      });
    });
    /* wildcard sniffer for undocumented alia:* events */
    try {
      var _de = document.dispatchEvent;
      document.dispatchEvent = function (ev) {
        try {
          if (ev && typeof ev.type === 'string' && ev.type.indexOf('alia:') === 0 && KNOWN.indexOf(ev.type.slice(5)) === -1) {
            emit('alia_event', { name: trunc(ev.type, 60), keys: ev.detail ? Object.keys(ev.detail).slice(0, 12) : [] });
          }
        } catch (e) {}
        return _de.apply(this, arguments);
      };
    } catch (e) {}

    function buildSnapshot(t, prevShow, lean) {
      var idleMs = P.idle ? (t - P.idleStart) : ((t - P.lastIdleEnd) < 10000 ? P.lastIdleMs : 0);
      var snap = {
        visit: C.v, pv_total: C.pv, pv_sess: sess.n,
        sec_page: r1((t - P.start) / 1000), sec_sess: r1((t - sess.start) / 1000),
        act_page: r1(P.act / 1000), act_sess: r1(sess.act / 1000),
        scroll: curScrollPct(), scroll_max: P.scrollMax,
        pt: CFG.pageType || '', product: productHandle(),
        cart: { items: cart.items, value: cart.value },
        exit5s: (t - lastExit) < 5000, idle_ms: Math.round(idleMs),
        trail: ring.slice(-30).map(function (e) { return { y: e.y, dt: t - e.t }; }),
        since_last_show_s: prevShow ? r1((t - prevShow) / 1000) : null,
        last_close_via: C.last_close || null, signed: C.signed || 0,
        dt_matched_ms: matchedAt ? (t - matchedAt) : null,
        device: { mob: isMobile(), vw: innerWidth, vh: innerHeight },
        ref: trunc(document.referrer, 160), utm: UTM, kl: klaviyoState()
      };
      // Full fires carry Alia's config bodies and storage state for reverse engineering.
      // Lean negatives omit them (config is identical across users and already captured) to
      // stay small, while keeping the full behavioral vector so they compare to positives.
      if (!lean) {
        var st = aliaStorage();
        snap.net = netBodies.slice(-8);
        snap.alia_ls = st.ls; snap.alia_ck = st.ck;
      }
      return snap;
    }

    function handleAlia(name, d) {
      var t = Date.now();

      if (name === 'campaignMatched') {
        matchedAt = t;
        emit('alia_matched', {
          campaignID: d.campaignID, campaignTitle: trunc(d.campaignTitle, 60),
          popupID: d.popupID, popupTitle: trunc(d.popupTitle, 60),
          dt_nav: Math.round(performance.now())
        });

      } else if (name === 'popupView') {
        /* dedupe repeated views while already open (step changes etc) */
        if (OPEN.active && OPEN.popupID === d.popupID) {
          emit('popup_view_repeat', { popupID: d.popupID });
          return;
        }
        // If the DOM fallback already counted this open, bind IDs instead of re-counting.
        if (OPEN.active && OPEN.source === 'dom' && OPEN.popupID == null) {
          OPEN.popupID = d.popupID; OPEN.campaignID = d.campaignID; OPEN.source = 'dom+sdk';
          emit('popup_id_bind', { campaignID: d.campaignID, popupID: d.popupID });
          return;
        }
        var manual = (t - aliaUiClick) < 1500;
        recordShow('sdk', { campaignID: d.campaignID, campaignTitle: d.campaignTitle, popupID: d.popupID }, manual);

      } else if (name === 'popupClose') {
        var via = (t - aliaUiClick) < 1200 ? 'click' : ((t - lastEsc) < 1200 ? 'esc' : 'other');
        C.last_close = via;
        var wasOpen = OPEN.at;
        OPEN.closedAt = t; OPEN.active = false;
        emit('popup_closed', {
          source: 'sdk', campaignID: d.campaignID, popupID: d.popupID,
          ms_open: wasOpen ? (t - wasOpen) : null, via: via
        });
        jSet('kwspy_c', C);

      } else if (name === 'signup') {
        var first = !C.signed;
        C.signed = 1; jSet('kwspy_c', C);
        var out = { campaignID: d.campaignID, popupID: d.popupID, has_email: !!d.email, has_phone: !!d.phone, first: first };
        var jobs = [];
        try {
          if (d.email && crypto.subtle) jobs.push(sha256(String(d.email).trim().toLowerCase()).then(function (h) { out.email_sha = h; }));
          if (d.phone && crypto.subtle) jobs.push(sha256(String(d.phone).replace(/[^0-9+]/g, '')).then(function (h) { out.phone_sha = h; }));
        } catch (e) {}
        var fin = function () { emit('popup_signup', out); markSubscribed(); };
        if (jobs.length) Promise.all(jobs).then(fin, fin); else fin();

      } else if (name === 'pollAnswered') {
        var ans = (d.answers || []).slice(0, 6).map(function (a) {
          return { q: trunc(a.questionText, 60), a: trunc(a.answerText, 60) };
        });
        emit('popup_poll', { campaignID: d.campaignID, popupID: d.popupID, answers: ans });

      } else if (name === 'rewardClaimed') {
        emit('popup_reward', {
          campaignID: d.campaignID, popupID: d.popupID,
          reward: trunc(d.rewardText, 60), code: !!d.discountCode
        });
      }
    }

    /* ---------------- init events ---------------- */
    if (newSession) {
      emit('session_start', {
        visit: C.v, ref: trunc(document.referrer, 200), utm: UTM,
        landing: trunc(location.pathname, 200),
        device: { mob: isMobile(), vw: innerWidth, vh: innerHeight, dpr: devicePixelRatio || 1, plat: trunc(navigator.platform || '', 20) },
        kl: klaviyoState(), nav: navType()
      });
    }
    sess.n = (sess.n || 0) + 1;
    C.pv = (C.pv || 0) + 1;
    jSet('kwspy_c', C);
    emit('page_view', { pt: CFG.pageType || '', n: sess.n, product: productHandle(), nav: navType() });

    /* alia fingerprint after their embed has had time to load */
    setTimeout(function () {
      var globals = [];
      try {
        globals = Object.keys(window).filter(function (k) { return ALIA_WORD.test(k); }).slice(0, 10);
      } catch (e) {}
      var scripts = [];
      try {
        scripts = Array.prototype.map.call(document.scripts, function (s) { return s.src; })
          .filter(function (s) { return s && aliaUrl(s); })
          .map(function (s) { return trunc(s, 180); }).slice(0, 6);
      } catch (e) {}
      var st = aliaStorage();
      scanPerf();
      emit('alia_fingerprint', {
        globals: globals, scripts: scripts, ls: st.ls, ck: st.ck,
        sdk: !!window.alia
      });
    }, 2500);

    if (CFG.debug) {
      window.__kwspy = { aid: aid, sid: sess.sid, q: Q, counters: C };
    }
  }
})();
